import React, { Component } from "react";
import "./Contact.scss";

class Contact extends Component {
  render() {
    return (
      <div className="container">
        <p>This is the contact page.</p>
        <p>Content for the contact page lives here.</p>
      </div>
    );
  }
}

export default Contact;
